export const checkoutUrl = 'https://complete-stretching-system.impultienda.ar/checkout'
export const offerAnchor = '#offer'
export const instagramUrl = 'https://www.instagram.com/bright_digital_hubonline'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/k52G3uGqmrXn5m3FgoqTjN/Imagen_de_ChatGPT_29_sept_2026,_09_51_12_p.m..png'

export const photos = {
  coachGroup:
    'https://cdn.magicpatterns.com/patterns/generated-images/2236f0ca-e6ae-4c40-a281-6c37173c1ce1.jpg',
  coachPlanning:
    'https://cdn.magicpatterns.com/patterns/generated-images/4880197f-4005-42cb-8cd7-a4a4a5d91249.jpg',
}

export const adjustments = ['Range', 'Support', 'Exercise Variation', 'Complexity']

export const sampleMeta = [
  ['Level', 'Intermediate+'],
  ['Total time', '50 min'],
  ['Primary goal', 'Pike Development'],
  ['Equipment', 'Mat + Blocks + Strap'],
] as const

export const sampleExercises = [
  ['Active Straight-Leg Raise', '3 × 6 each side', '—', 'Lift without leaning back'],
  ['Half Split', '2 sets each side', '40 sec', 'Move from the hips'],
  ['Elevated Hamstring Stretch', '2 sets each side', '40 sec', 'Keep the pelvis controlled'],
  ['Supported Pike', '2 sets', '45 sec', 'Hinge before reaching deeper'],
  ['Seated Compression Drill', '3 × 5', '—', 'Lift with control'],
] as const

export const heroSkills = ['Pike', 'Front Split', 'Middle Split', 'Pancake', 'Bridge', 'Active Flexibility']

export const trustChips = ['100% Digital', '52 Weeks', '156 Classes', 'Beginner → Advanced', '7-Day Guarantee']

export const stats = [
  ['6', 'Complete Volumes'],
  ['5', 'Professional Bonuses'],
  ['52', 'Weeks of Programming'],
  ['156', 'Ready-to-Teach Classes'],
  ['PDF', 'Digital Access'],
] as const

export const problems = [
  'What should I teach today?',
  'How long should each position be held?',
  'What should I do with beginners — and with advanced students?',
  'When should an exercise progress?',
  'How do I organize Pike, Splits, Pancake or Bridge training?',
  'How do I coach different levels inside the same group?',
]

export const solutionSteps = ['Open the volume.', 'Find the week.', 'Choose the class.', 'Follow the plan.']

export const howSteps = [
  {
    number: '01',
    title: 'Identify the level',
    text: "Observe the student's position, control, range and support requirements.",
  },
  {
    number: '02',
    title: 'Open the week',
    text: 'The complete program is organized from Week 1 through Week 52.',
  },
  {
    number: '03',
    title: 'Choose the class',
    text: 'Class A: Technique + Active Control. Class B: Targeted Flexibility. Class C: Complete Integration.',
  },
  {
    number: '04',
    title: 'Teach the session',
    text: 'Exercises, sets, reps, hold times, coaching cues, modifications and progressions — all programmed.',
  },
] as const

export const volumes = [
  {
    number: '01',
    name: 'Beginner Foundations',
    weeks: 'Weeks 1–8',
    classes: '24 Classes',
    color: '#3F6B4A',
    includes: ['Basic Positioning', 'Controlled Mobility', 'Hips, Ankles + Shoulders', 'Hamstrings + Adductors', 'Beginner Integration'],
  },
  {
    number: '02',
    name: 'Beginner Progressions',
    weeks: 'Weeks 9–16',
    classes: '24 Classes',
    color: '#2F5D7C',
    includes: ['Lower + Upper-Body Integration', 'Hip Rotation Development', 'Posterior Chain Development', 'Active Flexibility Introduction', 'Beginner+ Integration'],
  },
  {
    number: '03',
    name: 'Intermediate Foundations',
    weeks: 'Weeks 17–26',
    classes: '30 Classes',
    color: '#A86A1C',
    includes: ['Active Hamstring Control', 'Adductor Flexibility', 'Pancake Foundations', 'Shoulder + Thoracic Work', 'End-Range Control'],
  },
  {
    number: '04',
    name: 'Intermediate Progressions',
    weeks: 'Weeks 27–36',
    classes: '30 Classes',
    color: '#2B4F86',
    includes: ['Pike Development', 'Front + Middle Split Preparation', 'Pancake Development', 'Bridge Preparation', 'End-Range Strength'],
  },
  {
    number: '05',
    name: 'Advanced Flexibility Foundations',
    weeks: 'Weeks 37–44',
    classes: '24 Classes',
    color: '#9A7414',
    includes: ['Advanced Pike', 'Front + Middle Split Development', 'Advanced Pancake', 'Bridge Development', 'Active Flexibility'],
  },
  {
    number: '06',
    name: 'Advanced Flexibility Integration',
    weeks: 'Weeks 45–52',
    classes: '24 Classes',
    color: '#5B3F8C',
    includes: ['Front Split + Active Control', 'Middle Split + Adductor Control', 'Pancake + Compression', 'Bridge + Shoulder Control', 'Advanced 60-Minute Flows'],
  },
]
